var exports = {
  "k": "xfd349460--c9cfbe--container",
};

module.exports = exports;
